import Component from '@bythepixel/component-loader';
import Splide from '@splidejs/splide';
import { classes, selectors, splideSettings } from './config';

export default class VehicleTypeSubNav extends Component {
  static selector = '[data-comp-vehicle-type-sub-nav]';

  constructor(containerEl) {
    super(containerEl);

    this.splide = this.#buildSlider();
    this.track = containerEl.querySelector(selectors.track);
    this.slides = containerEl.querySelectorAll(selectors.slide);
    this.leftFade = containerEl.querySelector(selectors.leftFade);
    this.rightFade = containerEl.querySelector(selectors.rightFade);
    this.lastIndex = this.splide.Components.Controller.getEnd();

    this.mount();
  }

  hideFade(fadeEl) {
    fadeEl.classList.add(classes.hide);
  }

  showFade(fadeEl) {
    fadeEl.classList.remove(classes.hide);
  }

  isAtBeginning() {
    return this.splide.index === 0;
  }

  isAtEnd() {
    return this.splide.index === this.lastIndex;
  }

  updateFades() {
    if (this.isAtEnd()) {
      this.hideFade(this.rightFade);
      this.showFade(this.leftFade);

      return;
    }

    if (this.isAtBeginning()) {
      this.showFade(this.rightFade);
      this.hideFade(this.leftFade);

      return;
    }

    this.showFade(this.rightFade);
    this.showFade(this.leftFade);
  }

  scrollToActiveSlide() {
    const activeSlide = Array.from(this.slides).find(
      (slide) => slide.dataset.active === 'true',
    );

    if (!activeSlide) return;

    const activeIndex = Number(activeSlide.dataset.vehicleTypeSubNavSlide);

    if (!Number.isInteger(activeIndex)) return;

    this.splide.go(activeIndex);
    this.updateFades();
  }

  #buildSlider() {
    const perMove = parseInt(this.$container.dataset.slidesPerMove);
    const settings = {
      ...splideSettings,
      perMove,
    };
    // ensures that perMove only applies up to 1600px, wider screens keep default
    if (!settings.breakpoints[1600]) {
      settings.breakpoints[1600] = {};
    }
    settings.breakpoints[1600].perMove = perMove;

    return new Splide(this.$container, settings).mount();
  }

  #attachListeners() {
    this.splide.on('overflow', (isOverflowing) => {
      this.splide.options = {
        drag: isOverflowing ? 'free' : false,
      };
    });

    // because these are three different types of movements, we need to manage
    // our left/right fades on each of them
    this.splide.on('moved', this.updateFades.bind(this));
    this.splide.on('scrolled', this.updateFades.bind(this));
    this.splide.on('dragged', this.updateFades.bind(this));
  }

  mount() {
    this.#attachListeners();
    this.scrollToActiveSlide();
  }
}
